import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './visually-hidden.css.js';

var VisuallyHidden = function VisuallyHidden(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'span' : _ref$component,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["component", "children"]);

  return React.createElement(Component, _extends({
    className: styles.VisuallyHidden
  }, rest), children);
};

VisuallyHidden.displayName = 'VisuallyHidden';
VisuallyHidden.propTypes = process.env.NODE_ENV !== "production" ? {
  component: PropTypes.string,
  children: PropTypes.node
} : {};
export default VisuallyHidden;
export { VisuallyHidden };